<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <PlusCircleIcon v-tooltip="'追加'" class="ml-auto mr-3 text-indigo-500 hover:text-indigo-700 active:text-indigo-600 cursor-pointer w-8 h-8" @click="edit(null)" />
    <div class="overflow-hidden rounded main-height">
      <div class="main-height overflow-auto">
        <table class="overflow-auto main table-auto mb-3">
          <thead class="main sticky top-0 bg-white">
            <tr v-if="list && list.length" class="border border-gray-200">
              <th v-for="(c, index) in columns" :key="index" scope="col" class="px-2 py-3 text-xs font-medium text-gray-500 tracking-wider bg-colu text-left">
                {{c.title}}
              </th>
            </tr>
          </thead>

          <tr v-for="(row, i) in list" :key="i" class="border border-gray-200 tracking-wider hover:bg-teal-50">
            <!-- 会社名 -->
            <td :rowspan="row.cc" v-if="!list[i-1]||list[i-1].company!=row.company" class="px-2 py-3 whitespace-nowrap text-sm text-gray-700 min-300 bg-white">
              {{ row.company }}<p class="text-xs text-gray-700">{{ row.clientCode }}</p>
            </td>
            <!-- お役様担当者名 -->
            <td class="px-2 py-3 whitespace-nowrap text-sm text-gray-700 min-300">
              {{ row.name }}
            </td>
            <!-- メール -->
            <td class="px-2 py-3 whitespace-nowrap text-sm text-gray-700 min-300">
              {{ row.mail }}
            </td>

            <td class="px-2 py-0.5 text-center text-sm font-medium border-gray">
              <div class="flex justify-center">
                <PrimaryButton text="編集" size="normal" @click="edit(row)" />
              </div>
            </td>

            <td :rowspan="row.cc" v-if="!list[i-1]||list[i-1].company!=row.company" class="px-2 py-0.5 text-center text-sm font-medium border-gray bg-white">
              <div class="flex justify-center">
                <PrimaryButton text="追加" size="normal" class="bg-green-600" @click="add(row)" />
              </div>
            </td>
          </tr>
        </table>

      </div>
      <div v-if="!list || !list.length" class="flex justify-center items-center text-gray-500 font-bold nothing">
        <p class="text-gray-400 font-bold">対象データがありません</p>
      </div>

      <!-- 編集画面 -->
      <DentatsuMailMstEditModal 
        v-model="editModalShow"
        :open="editModalShow"
        :target="editData"
        @close="closeModal"
      />
    </div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import DentatsuMailMstEditModal from '../components/DentatsuMailMstEditModal.vue'
// import * as estimateManager from '@managers/estimateManager'
// import * as utils from '@libs/utils'
import { PlusCircleIcon } from '@vue-hero-icons/solid'
import * as backend from '@libs/backend'
export default {
  components: {
      Modal,
      PrimaryButton,
      DentatsuMailMstEditModal,
      PlusCircleIcon
  },

  props: ['open'],

  data() {
    return {
      // カラム
      columns: [
          {title: '会社名'},
          {title: 'お客様担当者'},
          {title: 'メールアドレス'},
          {title: ''},
          {title: ''},
      ],
      list: [],
      // 編集モーダル
      editModalShow: false,
      // 編集対象データ
      editData: []
    }
  },

  computed: {
  },

  watch: {
    open() {
      if (this.open) {
        this.getData()
      }
    }
  },

  methods: {
    async getData() {
      const res = await backend.searchData('mail/getData', { type: 2 })
      if (res.data.data) {
        this.list = res.data.data
      } else { 
        this.list = []
      }
    },

    /**
     * 編集ボタンイベント
     * @param row 編集対象データ
     */
    edit(row) {
      this.editData = null
      // 編集
      if (row) {
        this.editData = row
      }
      this.editModalShow = true
    },

    /**
     * 同じ会社追加ボタンイベント
     * @param row 編集対象データ
     */
    add(row) {
      this.editData = null
      // 編集
      if (row) {
        this.editData = { company: row.company }
      }
      this.editModalShow = true
    },

    /**
     * 編集モーダルclode
     */
    closeModal() {
      this.editModalShow = false
      this.getData()
    },

    closed() {
      this.$emit('close')
      this.list = []
    }
  }
}
</script>
<style scoped>
.main-height {
  height: 85vh;
}

.main {
  min-width: 700px;
}

.min-300 {
  min-width: 300px;
}

.bg-colu {
  background: #ebfbec;
}

.nothing {
  position: absolute;
  top: 45%;
  left: 40%;
}

@media screen and (max-width: 1200px) {
  .main {
    overflow: auto;
  }
}
</style>